import { render, staticRenderFns } from "./MyUploadsModal.vue?vue&type=template&id=16fadb32&scoped=true"
import script from "./MyUploadsModal.vue?vue&type=script&lang=js"
export * from "./MyUploadsModal.vue?vue&type=script&lang=js"
import style0 from "./MyUploadsModal.vue?vue&type=style&index=0&id=16fadb32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fadb32",
  null
  
)

export default component.exports